import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import AppModel from '../DataModel/AppModel';
import JobList from '../components/JobList';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';

import RefreshIndicator from 'material-ui/RefreshIndicator';


const style = {
  height: 100,
  margin: 40,
  padding:20,
  textAlign: 'center',
  display: 'inline-block',
};

export default
@observer class JobsPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  gotoJobDetailPage(job) {
    var id_machine=job.id_machine;
    var starttime=job.start_time.getTime();
    var self = this;
    return function() {
      self.context.router.push(`/jobs/job/${id_machine}/${starttime}`);
    }
  }
  
  render() {
    var self = this;
    
    // Rendering the JobList page
    return (
      <PageLoading loading={AppModel.fetchingJobList && !AppModel.fetchingMoreJobs}>
        <JobList jobs={AppModel.sortedJobList} ></JobList>
        <RefreshIndicator style={{ position: 'fixed'}} left={document.documentElement.clientWidth - 63} top={window.innerHeight - 63} status={AppModel.fetchingMoreJobs ? 'loading' : 'hide'}/>

      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/JobsPage.jsx
 **/